import * as React from 'react'
import { useFormikContext } from 'formik'

import { FormControlLabel } from '../../../atoms'
import type { LocAndSvcsFormModel } from '../formConfig'
import type { CheckedHandler, InputProps, CheckboxOption } from '../typings'
import Checkbox from '@mui/material/Checkbox'

type ServiceCheckboxProps = {
  disabled?: boolean
  service: CheckboxOption
  onChange: CheckedHandler
}

export function ServiceCheckbox(props: ServiceCheckboxProps) {
  const {
    onChange,
    service: { id, label, scheduled },
  } = props

  const disabled = scheduled || props.disabled

  const inputProps: InputProps = {
    'data-test-id': `locAndSvcs-svcCheckbox-${id}`,
  }

  const {
    values: { serviceIds },
  } = useFormikContext<LocAndSvcsFormModel>()

  const checked = serviceIds.get(id) ?? false

  return (
    <FormControlLabel
      value={id}
      label={label}
      name="serviceIds"
      checked={checked}
      onChange={onChange}
      disabled={disabled}
      control={<Checkbox inputProps={inputProps} />}
    />
  )
}
